export enum CustomerInfo {
  VIN = 'VIN',
  ZIP = 'ZIP',
  DOB = 'DOB',
  SSN = 'SSN',
  SSN_LAST_6 = 'SSN_LAST_6',
  SSN_LAST_4 = 'SSN_LAST_4',
  PHONE_NUMBER = 'PHONE_NUMBER',
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  CURRENT_ODOMETER = 'CURRENT_ODOMETER',
}

export type CustomerInfoValues = {
  [K in typeof CustomerInfo[keyof typeof CustomerInfo]]: string;
};

type Option = CustomerInfo[];
// Array of arrays.
type Options = Option[];

// Possible values for the `value` field of the `digital` payoff method.
export enum DigitalPayoffMethodValueEnum {
  FALSE = 'FALSE',
  ROUTE_ONE = 'ROUTE_ONE',
  DEALER_TRACK = 'DEALER_TRACK',
  DEALER_LOGIN = 'DEALER_LOGIN',
}

export const REQUIRED_DIGITAL_PAYOFF_OPTION = [CustomerInfo.VIN, CustomerInfo.CURRENT_ODOMETER];

// eslint-disable-next-line @typescript-eslint/ban-types
type Value = 'TRUE' | 'FALSE' | DigitalPayoffMethodValueEnum | (string & {});
type PayoffMethod = { value: Value; options?: Options } | string;
export type PayoffMethods = { [key: string]: PayoffMethod };

export type LienholderPRSType = {
  id: number;
  display_name: string;
  slug: string;
  phone_numbers: [{ name: string; phone_numbers: [string] }];
  requirements_to_get_payoff: {
    id: string;
    options: Options;
    get_payoff_methods: PayoffMethods;
  };
  requirements_to_payoff_lease: {
    [key: string]: { value: boolean };
  };
  required_documents_to_payoff_lease: {
    [key: string]: { value: boolean };
  };
  double_tax: boolean;
  third_party_payoffs: boolean;
  probableLienholder: boolean;
  enabled: boolean;
  is_core: boolean;
};

export type LienholderPRSFormType = {
  phone_numbers: string[];
  payoff_methods: { key: string; value: string }[];
  payoff_requirements: string[][];
};
